import {CommentBox, type CommentBoxHandle, type CommentBoxProps} from '@github-ui/comment-box/CommentBox'
import type React from 'react'

import {useComparisonInfo, usePullRequest, useRepository} from '@github-ui/pull-requests/pull-request-store-selectors'
import type {RepoSubject} from '@github-ui/comment-box/subject'

export type ConversationCommentBoxProps = Omit<CommentBoxProps, 'children' | 'body'> & {
  children?: React.ReactNode
  label: string
  value: string
  ref?: React.Ref<CommentBoxHandle>
}

export const ConversationCommentBox = ({ref, children, ...rest}: ConversationCommentBoxProps) => {
  const pullRequest = usePullRequest()
  const {baseRepository: repository} = useRepository()
  const comparisonInfo = useComparisonInfo()
  const subject: RepoSubject = {
    type: 'pull_request',
    id: {
      id: pullRequest.id,
    },
    pullRequestNumber: pullRequest.number,
    repository: {
      databaseId: repository.id,
      nwo: `${repository.ownerLogin}/${repository.name}`,
      slashCommandsEnabled: false, // TODO - follow up on this
    },
    comparison: {
      startCommitOid: comparisonInfo.effectiveRange.baseOid,
      endCommitOid: comparisonInfo.effectiveRange.headOid,
    },
  }

  return (
    <CommentBox
      {...rest}
      ref={ref}
      placeholder="Leave a comment"
      actions={children}
      subject={subject}
      showLabel={false}
    />
  )
}

ConversationCommentBox.displayName = 'ConversationCommentBox'
